import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>ahare vai kitten aisen iyane!</h1>
        </div>
    );
};

export default NotFound;